import React, { useContext, useEffect, useState } from 'react'
import { Avatar, Box, Typography, Stack,Dialog  } from '@mui/material';
import { UserContext } from "../Root/Root";
import EditIcon from '@mui/icons-material/Edit';
import { GET_FILE_URL } from '../Graphql/Queries/getFileUrl';
import { fetchData } from '../Service/graphQlService';

const UserProfileDetails = () => {
    const [open, setOpen] = useState(false);
    const [photoUrl,setPhotoUrl] = useState("")
     const user = useContext(UserContext);
const firstName = (user && user.userData && user.userData.firstName) || (user && user.userData && user.userData.username) || '';
const lastName = (user && user.userData && user.userData.lastName) || '';

const fullName = firstName
  ? firstName.charAt(0).toUpperCase() + firstName.slice(1) + (lastName ? ' ' + lastName.charAt(0).toUpperCase() + lastName.slice(1) : '')
  : '';
  const handleEditClick = (userId) => {
    const baseUrl = location.origin;
  const url = `${baseUrl}/users/${userId}`;
  window.location.href = url;
};
const photoData = user && user.userData && user.userData.photo ? user.userData.photo : ""
 const role = user && user.userData && user.userData.type
  ? user.userData.type.charAt(0).toUpperCase() + user.userData.type.slice(1)
  : "";
  const userId = user && user.userData && user.userData.id ? user.userData.id : ""
  //  const avatarUrl = "https://media.licdn.com/dms/image/v2/C4E03AQFyEYdTSXTOXg/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1516698661504?e=2147483647&v=beta&t=x13rJF8nyYgs5M_kKAX8itlY0qDuPsXD9ntn6NH9P_o";
   useEffect(() => {
const fetchPhoto = async () => {
  if (!photoData) {
    console.log("photoData is empty, skipping API call");
    return;
  }

  // Check if photoData is already a URL
  if (photoData.startsWith("http://") || photoData.startsWith("https://")) {
    setPhotoUrl(photoData);
    return;
  }

  try {
    const response = await fetchData(GET_FILE_URL, { id: photoData });

    if (
      response &&
      response.data &&
      response.data.getFile &&
      response.data.getFile.fileUrl
    ) {
      const imageUrl = response.data.getFile.fileUrl;
      setPhotoUrl(imageUrl);
    } else {
      console.error("Image URL not found in response:", response);
    }

  } catch (error) {
    console.error('Fetch error:', error);
  }
};


  fetchPhoto();
}, [photoData]);
  return (
    <div>
 <Box
        sx={{
          position: 'fixed',
          top: 8,
          right: 16,
          zIndex: 9999,
        }}
      >
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          sx={{
            backgroundColor: '#2b2b2b',
            padding: '2px 14px',
            borderRadius: '12px',
            border: '1px solid #444',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          }}
        >
          {/* Avatar - Clickable */}
          <Avatar
            alt={fullName}
            src={photoUrl}
            onClick={() => setOpen(true)}
            sx={{
              width: 42,
              height: 42,
              border: '2px solid white',
              boxShadow: '0 0 4px rgba(255, 255, 255, 0.3)',
              cursor: 'pointer',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.05)',
              },
            }}
            >
               {firstName ? firstName.charAt(0).toUpperCase() : '?'}
            </Avatar>

          {/* Role + Name */}
          <Box>
            <Typography variant="body1" sx={{ fontWeight: 600, color: '#7EB233', lineHeight: 1,marginLeft:"8px" }}>
              {fullName}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                backgroundColor: '#7EB23320',
                color: '#7EB233',
                padding: '2px 8px',
                borderRadius: '8px',
                fontSize: '11px',
                fontWeight: 600,
                display: 'inline-block',
                marginBottom: '2px',
              }}
            >
              {role}
            </Typography>
               {/* <EditIcon sx={{ fontSize: 18, color:"#7EB233", cursor: 'pointer',ml:1, top: '4px', position: 'relative', }} onClick={() => handleEditClick(userId)} /> */}
         
          </Box>
        </Stack>
      </Box>

      {/* Fullscreen Avatar Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs">
        <Box
          sx={{
            p: 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#000',
          }}
        >
          <img
            src={photoUrl}
            alt={fullName}
            style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: '12px' }}
          />
        </Box>
      </Dialog>
    </div>
  )
}

export default UserProfileDetails
